export interface PillProps {
  variant: PillsVariant;
  value: string;
  label?: string;
  icon?: React.ElementType;
  tooltipText?: string;
  onEntityClick?: (id: string, type: string) => void;
  id?: string;
  type?: string;
  customOnClick?: () => void;
  href?: string;
}

export enum PillsVariant {
  default = "default",
  warning = "warning",
  danger = "danger",
}
